module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-layout"
  }, [_c('p', {
    staticClass: "app-info"
  }, [_c('small', [_vm._v("Powered By ICT - v" + _vm._s(_vm.version))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSaver),
      expression: "showSaver"
    }],
    staticClass: "top-panel",
    attrs: {
      "id": "top-panel"
    },
    on: {
      "click": _vm.closeScreenSaver
    }
  }, [_c('div', {
    staticClass: "logo-wrap"
  }, [_c('p', [_vm._v("電子藥櫃操作系統")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [(_vm.connected) ? _c('img', {
    staticClass: "connect-icon",
    attrs: {
      "src": "/static/svg/wifi-green.svg",
      "alt": "connected",
      "id": "connected-icon"
    }
  }) : _c('img', {
    staticClass: "connect-icon",
    attrs: {
      "src": "/static/svg/wifi-red.svg",
      "alt": "disconnected",
      "id": "disconnected-icon"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.connectionMsg))])]), (_vm.connected) ? _c('p', [_c('small', [_vm._v("Last connected time: " + _vm._s(_vm.lastConnectedTime))])]) : _c('p', [_c('small', [_vm._v("Last retry time: " + _vm._s(_vm.lastRetryTime))])]), _vm._v(" "), _c('p')]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.$store.state.generalSetting) ? _c('div', {
    staticClass: "bottom-panel",
    attrs: {
      "id": "bottom-panel"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "col-6 barcode-login-panel"
  }, [_c('div', {
    ref: "barcode",
    staticClass: "login-method-wrap"
  }, [_c('ScanBarcode', {
    on: {
      "setBarcode": _vm.getBarcodeToLogin
    }
  }, [_c('div', {
    staticClass: "login-type--img"
  }, [_c('div', [_c('img', {
    staticClass: "m-2",
    attrs: {
      "src": "/static/svg/barcode-black.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "m-2",
    attrs: {
      "src": "/static/svg/fingerprint-black.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("\n                請掃描條碼 / 指紋登入 \n              ")]), _vm._v(" "), _c('h6', [(_vm.$store.state.generalSetting.can_login_with_fingerprinter === false) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("指紋功能未開啟")]) : _c('span', [(_vm.$store.state.fingerprinterConnected) ? _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("(指紋機已連線)")]) : _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(指紋機未連線)")])])])])])], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-6 account-login-panel"
  }, [_c('form', {
    ref: "password",
    staticClass: "login-method-wrap",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "username",
      "onkeypress": "if (event.keyCode == 13) {return false;}"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "onkeypress": "if (event.keyCode == 13) {return false;}"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg login-button",
    attrs: {
      "type": "submit",
      "id": "login-submit"
    }
  }, [_vm._v("\n            帳號登入\n          ")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triangle-wrap"
  }, [_c('p', {
    staticClass: "login-hint"
  }, [_vm._v("點選以登入")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("帳號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("密碼")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1592b4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1548
// module chunks = 1